"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringFn = {
    /**
     * 判断值val为空时，返回默认想展示的内容defaultVal || --
     * @param {*} val
     * @param {*} defaultVal
     */
    s: function (a, b) {
        if (a === null || a === undefined || a === '') {
            return b ? b : '--';
        }
        else {
            return a;
        }
    },
    /**
     * 判断值val为是否为空，排除 null,undefined,''
     * @param {*} val
     */
    hasValue: function (val) {
        if (val === null || val === undefined || val === '') {
            return false;
        }
        else {
            return true;
        }
    },
    // 给url添加参数
    urlAddParams: function (url, params) {
        if (typeof (url) == 'undefined' || url == null || url == '') {
            return '';
        }
        if (typeof (params) == 'undefined' || params == null || typeof (params) != 'object') {
            return url;
        }
        url += (url.indexOf("?") != -1) ? "" : "?";
        for (var k in params) {
            url += ((url.indexOf("=") != -1) ? "&" : "") + k + "=" + encodeURI(params[k]);
        }
        return url;
    },
    /**
     * 将编码由utf8转为utf16
     * @param {需要编码的字符串} str
     */
    utf8to16: function (str) {
        var out, i, len, c;
        var char2, char3;
        out = "";
        len = str.length;
        i = 0;
        while (i < len) {
            c = str.charCodeAt(i++);
            switch (c >> 4) {
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    // 0xxxxxxx
                    out += str.charAt(i - 1);
                    break;
                case 12:
                case 13:
                    // 110x xxxx   10xx xxxx
                    char2 = str.charCodeAt(i++);
                    out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
                    break;
                case 14:
                    // 1110 xxxx  10xx xxxx  10xx xxxx
                    char2 = str.charCodeAt(i++);
                    char3 = str.charCodeAt(i++);
                    out += String.fromCharCode(((c & 0x0F) << 12) |
                        ((char2 & 0x3F) << 6) |
                        ((char3 & 0x3F) << 0));
                    break;
            }
        }
        return out;
    },
    /**
     * 将编码由utf16转为utf8
     * @param {需要编码的字符串} str
     */
    utf16to8: function (str) {
        var out, i, len, c;
        out = "";
        len = str.length;
        for (i = 0; i < len; i++) {
            c = str.charCodeAt(i);
            if ((c >= 0x0001) && (c <= 0x007F)) {
                out += str.charAt(i);
            }
            else if (c > 0x07FF) {
                out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
                out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
                out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
            }
            else {
                out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
                out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
            }
        }
        return out;
    },
    /**
     * 对字符串进行base64编码
     * @param {待编码的字符串} str
     */
    encodeBase64: function (str) {
        str = this.utf16to8(str);
        var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        do {
            chr1 = str.charCodeAt(i++);
            chr2 = str.charCodeAt(i++);
            chr3 = str.charCodeAt(i++);
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            }
            else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) +
                keyStr.charAt(enc3) + keyStr.charAt(enc4);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
        } while (i < str.length);
        return output;
    },
    /**
     * 对字符串进行base64解码
     * @param {待解码的字符串} str
     */
    decodeBase64: function (str) {
        var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        if (str.length % 4 != 0) {
            return "";
        }
        var base64test = /[^A-Za-z0-9\+\/\=]/g;
        if (base64test.exec(str)) {
            return "";
        }
        do {
            enc1 = keyStr.indexOf(str.charAt(i++));
            enc2 = keyStr.indexOf(str.charAt(i++));
            enc3 = keyStr.indexOf(str.charAt(i++));
            enc4 = keyStr.indexOf(str.charAt(i++));
            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 != 64) {
                output += String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output += String.fromCharCode(chr3);
            }
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
        } while (i < str.length);
        return unescape(this.utf8to16(output));
    }
};
exports.default = exports.StringFn;
//# sourceMappingURL=String.js.map